import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header__parent" }
const _hoisted_2 = { class: "header__parent--left" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Dashboard")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("API Access")
const _hoisted_5 = {
  key: 0,
  class: "header__parent--right"
}
const _hoisted_6 = { class: "mini-profile" }
const _hoisted_7 = { class: "mini-profile--info" }
const _hoisted_8 = { class: "w-s-nw c-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconFeather = _resolveComponent("IconFeather")!
  const _component_IconApiConnect = _resolveComponent("IconApiConnect")!
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass({ hijacking: _ctx.hijackingToken })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/dashboard" }, {
          default: _withCtx(() => [
            _createVNode(_component_Logo, { header: "" })
          ]),
          _: 1
        }),
        _createElementVNode("nav", null, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "w-s-nw dashboard",
                to: "/dashboard"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconFeather),
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "w-s-nw api",
                to: "/api"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconApiConnect),
                  _hoisted_4
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      (_ctx.profile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/settings" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Avatar, {
                    class: "m-right-15",
                    border: "",
                    size: 42
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.profile.first_name) + " " + _toDisplayString(_ctx.profile.last_name), 1)
                    ]),
                    (_ctx.profile.subscription.plan)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["w-s-nw", _ctx.profile.subscription.plan])
                        }, _toDisplayString(_ctx.SUBSCRIPTION_PLAN_TITLE[_ctx.profile.subscription.plan]), 3))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }),
            (_ctx.profile.subscription.plan === _ctx.SUBSCRIPTION_PLAN.free)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn blue mini upgrade m-left-70",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.upgrade && _ctx.upgrade(...args)))
                }, " Upgrade "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}